// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_9fb36563","isFixed":"_422e337c","image":"_6b115157","title":"_e6c4e250","icon":"_4cb4e11b","copy":"_313ad975","message":"_a1016a3b","messageBold":"_e6a7d5be"};